
import { TableBody, TableCell, TableRow } from "@/components/ui/table";
import { Staff } from "@/types/staff";
import { StaffTableRow } from "./StaffTableRow";

interface TableContentProps {
  loading: boolean;
  staff: Staff[];
  searchQuery: string;
  onDelete: (staff: Staff) => void;
  onStaffUpdated: () => void;
}

export const TableContent = ({
  loading,
  staff,
  searchQuery,
  onDelete,
  onStaffUpdated,
}: TableContentProps) => {
  if (loading) {
    return (
      <TableBody>
        <TableRow>
          <TableCell colSpan={4} className="text-center py-4">
            Loading...
          </TableCell>
        </TableRow>
      </TableBody>
    );
  }

  if (staff.length === 0) {
    return (
      <TableBody>
        <TableRow>
          <TableCell colSpan={4} className="text-center py-4">
            {searchQuery ? "No matching staff found" : "No staff found"}
          </TableCell>
        </TableRow>
      </TableBody>
    );
  }

  return (
    <TableBody className="[&>tr:last-child]:border-0">
      {staff.map((staff) => (
        <StaffTableRow
          key={staff.id}
          staff={staff}
          onDelete={onDelete}
          onStaffUpdated={onStaffUpdated}
        />
      ))}
    </TableBody>
  );
};
